(function () {
  const root = document.querySelector("[data-collection-bouquet]");
  if (!root) return;

  const filtersDrawer = root.querySelector("[data-filter-drawer]");
  const filterBackdrop = root.querySelector("[data-filter-backdrop]");
  const openFiltersButton = root.querySelector("[data-open-filters]");
  const closeFiltersButton = root.querySelector("[data-close-filters]");
  const filterForm = root.querySelector("[data-bouquet-filters-form]");
  const sortSelect = root.querySelector("[data-collection-sort]");
  const perPageSelect = root.querySelector("[data-per-page-select]");
  const viewButtons = root.querySelectorAll("[data-view-mode]");
  const searchWrap = root.querySelector("[data-collection-search]");
  const searchInput = root.querySelector("[data-collection-search-input]");
  const searchSuggestions = root.querySelector("[data-collection-search-suggestions]");
  const searchClear = root.querySelector("[data-collection-search-clear]");
  const productCards = Array.from(root.querySelectorAll("[data-product-card]"));
  const storageKey = "bouquetCollectionView";
  let predictiveAbortController = null;
  let searchToken = 0;

  function setDrawer(open) {
    if (!filtersDrawer) return;
    root.classList.toggle("is-filter-open", open);
    openFiltersButton?.setAttribute("aria-expanded", String(open));
    if (filterBackdrop) filterBackdrop.hidden = !open;
    if (open) {
      window.BouquetScrollLock?.lock({
        owner: "collection-filters",
        className: "overflow-hidden",
        target: document.documentElement,
      }) ?? document.documentElement.classList.add("overflow-hidden");
    } else {
      window.BouquetScrollLock?.unlock({ owner: "collection-filters" }) ??
        document.documentElement.classList.remove("overflow-hidden");
    }
    if (open) {
      closeFiltersButton?.focus();
    } else {
      openFiltersButton?.focus();
    }
  }

  function submitFilterForm() {
    if (!filterForm) return;
    preparePriceSubmission();
    filterForm.querySelectorAll("[data-price-hidden]").forEach((input) => {
      if (!input.value.trim()) input.disabled = true;
    });
    filterForm.submit();
  }

  function formatEuros(value) {
    const number = Number(value || 0);
    return `${Math.round(number)} €`;
  }

  function clamp(number, min, max) {
    return Math.min(Math.max(Number(number) || 0, min), max);
  }

  function priceValues(wrapper) {
    const minBound = Number(wrapper.dataset.priceMin || 0);
    const maxBound = Math.max(minBound, Number(wrapper.dataset.priceMax || 0));
    const minRange = wrapper.querySelector("[data-price-range-min]");
    const maxRange = wrapper.querySelector("[data-price-range-max]");
    let min = clamp(minRange?.value, minBound, maxBound);
    let max = clamp(maxRange?.value, minBound, maxBound);

    if (min > max) [min, max] = [max, min];
    return { minBound, maxBound, min, max };
  }

  function syncPriceSlider(wrapper, source) {
    const minRange = wrapper.querySelector("[data-price-range-min]");
    const maxRange = wrapper.querySelector("[data-price-range-max]");
    const minField = wrapper.querySelector("[data-price-field-min]");
    const maxField = wrapper.querySelector("[data-price-field-max]");
    const hiddenMin = wrapper.querySelector("[data-price-hidden-min]");
    const hiddenMax = wrapper.querySelector("[data-price-hidden-max]");
    const summary = wrapper.querySelector("[data-price-summary]");
    const { minBound, maxBound, min, max } = priceValues(wrapper);
    const span = Math.max(maxBound - minBound, 1);
    const left = ((min - minBound) / span) * 100;
    const right = ((max - minBound) / span) * 100;

    wrapper.style.setProperty("--price-left", `${left}%`);
    wrapper.style.setProperty("--price-right", `${right}%`);
    wrapper.dataset.priceTouched = source ? "true" : wrapper.dataset.priceTouched || "";

    if (minRange) minRange.value = String(min);
    if (maxRange) maxRange.value = String(max);
    if (minField) minField.value = String(Math.round(min));
    if (maxField) maxField.value = String(Math.round(max));
    if (summary) summary.textContent = `${formatEuros(min)} - ${formatEuros(max)}`;

    const touched = wrapper.dataset.priceTouched === "true";
    if (hiddenMin) hiddenMin.value = touched && min > minBound ? String(Math.round(min)) : "";
    if (hiddenMax) hiddenMax.value = touched && max < maxBound ? String(Math.round(max)) : "";

    updatePriceBars(wrapper, min, max);
  }

  function preparePriceSubmission() {
    root.querySelectorAll("[data-price-slider]").forEach((wrapper) => {
      syncPriceSlider(wrapper, "submit");
    });
  }

  function priceNumbers() {
    return productCards
      .map((card) => Number(card.dataset.priceCents || 0) / 100)
      .filter((price) => Number.isFinite(price) && price >= 0);
  }

  function updatePriceBars(wrapper, min, max) {
    const bars = wrapper.querySelectorAll("[data-price-bar]");
    if (!bars.length) return;
    bars.forEach((bar) => {
      const low = Number(bar.dataset.binMin || 0);
      const high = Number(bar.dataset.binMax || low);
      bar.classList.toggle("is-in-range", high >= min && low <= max);
    });
  }

  function buildPriceHistogram(wrapper) {
    const barsWrap = wrapper.querySelector("[data-price-bars]");
    if (!barsWrap) return;

    const prices = priceNumbers();
    const { minBound, maxBound, min, max } = priceValues(wrapper);
    const binCount = 12;
    const span = Math.max(maxBound - minBound, 1);
    const bins = Array.from({ length: binCount }, () => 0);

    prices.forEach((price) => {
      const index = Math.min(binCount - 1, Math.max(0, Math.floor(((price - minBound) / span) * binCount)));
      bins[index] += 1;
    });

    const peak = Math.max(...bins, 1);
    barsWrap.replaceChildren();

    bins.forEach((count, index) => {
      const bar = document.createElement("span");
      const binMin = minBound + (span / binCount) * index;
      const binMax = minBound + (span / binCount) * (index + 1);
      bar.className = "facets-bouquet__price-bar";
      bar.dataset.priceBar = "";
      bar.dataset.binMin = String(binMin);
      bar.dataset.binMax = String(binMax);
      bar.style.setProperty("--bar-height", `${Math.max(10, (count / peak) * 100)}%`);
      bar.title = `${Math.round(binMin)} € - ${Math.round(binMax)} €`;
      barsWrap.appendChild(bar);
    });

    syncPriceSlider(wrapper);
    updatePriceBars(wrapper, min, max);
  }

  function initPriceSliders() {
    root.querySelectorAll("[data-price-slider]").forEach((wrapper) => {
      const minRange = wrapper.querySelector("[data-price-range-min]");
      const maxRange = wrapper.querySelector("[data-price-range-max]");
      const minField = wrapper.querySelector("[data-price-field-min]");
      const maxField = wrapper.querySelector("[data-price-field-max]");
      const hiddenMin = wrapper.querySelector("[data-price-hidden-min]");
      const hiddenMax = wrapper.querySelector("[data-price-hidden-max]");

      if (hiddenMin?.value || hiddenMax?.value) wrapper.dataset.priceTouched = "true";
      buildPriceHistogram(wrapper);

      [minRange, maxRange, minField, maxField].forEach((input) => {
        input?.addEventListener("input", () => {
          if (input === minField && minRange) minRange.value = input.value;
          if (input === maxField && maxRange) maxRange.value = input.value;
          syncPriceSlider(wrapper, "input");
        });
        input?.addEventListener("change", () => syncPriceSlider(wrapper, "change"));
      });
    });
  }

  function updateUrlParam(name, value) {
    const url = new URL(window.location.href);
    if (value) {
      url.searchParams.set(name, value);
    } else {
      url.searchParams.delete(name);
    }
    url.searchParams.delete("page");
    window.location.href = url.toString();
  }

  function collectionSearchUrl(query) {
    const url = new URL("/collections/all", window.location.origin);
    const trimmed = String(query || "").trim();
    if (trimmed) url.searchParams.set("q", trimmed);
    return `${url.pathname}${url.search}`;
  }

  function updatePerPage(value) {
    const url = new URL(window.location.href);
    const viewsBySize = {
      24: "per-page-24",
      36: "per-page-36",
    };
    const nextView = viewsBySize[String(value)];

    url.searchParams.delete("page");
    url.searchParams.delete("per_page");
    if (nextView) {
      url.searchParams.set("view", nextView);
    } else {
      url.searchParams.delete("view");
    }
    window.location.href = url.toString();
  }

  function setViewMode(mode) {
    const nextMode = mode === "list" ? "list" : "grid";
    root.dataset.view = nextMode;
    viewButtons.forEach((button) => {
      const active = button.dataset.viewMode === nextMode;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", String(active));
    });
    try {
      window.localStorage.setItem(storageKey, nextMode);
    } catch (error) {
      // Private mode can block storage; visual toggle still works.
    }
  }

  function normalizeText(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  }

  function cardSuggestion(card) {
    const title = card.dataset.searchTitle || card.querySelector(".product-card-bouquet__title")?.textContent || "";
    const media = card.dataset.searchImage || card.querySelector(".product-card-bouquet__media img")?.currentSrc || "";
    return {
      title: title.trim(),
      url: card.dataset.searchUrl || card.querySelector("a[href]")?.getAttribute("href") || "",
      image: media,
      price: card.dataset.searchPrice || card.querySelector(".product-card-bouquet__price")?.textContent?.trim() || "",
    };
  }

  function formatSuggestionPrice(value) {
    const raw = String(value || "").trim();
    if (!raw) return "";
    if (raw.includes("€")) return raw;
    const number = Number(raw);
    if (Number.isNaN(number)) return raw;
    return `${number.toFixed(2).replace(".", ",")}€`;
  }

  function productSuggestion(product) {
    const image = product.image || product.featured_image?.url || product.featured_image || "";
    return {
      title: product.title || "",
      url: product.url || "",
      image: typeof image === "string" ? image : image?.url || "",
      price: formatSuggestionPrice(product.price || product.price_min || ""),
    };
  }

  function mergeSuggestions(localItems, remoteItems) {
    const seen = new Set();
    return [...localItems, ...remoteItems].filter((item) => {
      if (!item.title || !item.url) return false;
      const key = item.url.split("?")[0];
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    }).slice(0, 5);
  }

  function localSuggestions(query) {
    const needle = normalizeText(query);
    if (!needle) return productCards.slice(0, 5).map(cardSuggestion);
    return productCards
      .map(cardSuggestion)
      .filter((item) => normalizeText(item.title).includes(needle))
      .slice(0, 5);
  }

  function setSearchOpen(open) {
    if (!searchInput || !searchSuggestions) return;
    searchSuggestions.hidden = !open;
    searchInput.setAttribute("aria-expanded", String(open));
  }

  function clearSuggestions() {
    if (!searchSuggestions) return;
    searchSuggestions.replaceChildren();
    setSearchOpen(false);
  }

  function buildSuggestion(item) {
    const link = document.createElement("a");
    link.className = "collection-bouquet__suggestion";
    link.href = item.url;
    link.setAttribute("role", "option");

    if (item.image) {
      const image = document.createElement("img");
      image.src = item.image;
      image.alt = "";
      image.loading = "lazy";
      link.appendChild(image);
    } else {
      const placeholder = document.createElement("span");
      placeholder.className = "collection-bouquet__suggestion-placeholder";
      placeholder.textContent = item.title.charAt(0);
      link.appendChild(placeholder);
    }

    const body = document.createElement("span");
    const title = document.createElement("strong");
    title.textContent = item.title;
    body.appendChild(title);

    if (item.price) {
      const price = document.createElement("span");
      price.textContent = item.price;
      body.appendChild(price);
    }

    link.appendChild(body);
    return link;
  }

  function buildSearchLink(query) {
    const link = document.createElement("a");
    link.className = "collection-bouquet__suggestion collection-bouquet__suggestion--search";
    link.href = collectionSearchUrl(query);
    link.setAttribute("role", "option");
    link.textContent = `Voir tous les résultats pour "${query}"`;
    return link;
  }

  function renderSuggestions(query, remoteItems = []) {
    if (!searchSuggestions) return;
    const trimmedQuery = query.trim();
    const items = mergeSuggestions(localSuggestions(trimmedQuery), remoteItems);

    searchSuggestions.replaceChildren();

    if (items.length === 0 && trimmedQuery.length < 2) {
      clearSuggestions();
      return;
    }

    items.forEach((item) => searchSuggestions.appendChild(buildSuggestion(item)));

    if (trimmedQuery.length >= 2) {
      searchSuggestions.appendChild(buildSearchLink(trimmedQuery));
    }

    setSearchOpen(true);
  }

  async function fetchPredictiveSuggestions(query, token) {
    if (query.trim().length < 2) return;
    predictiveAbortController?.abort();
    predictiveAbortController = new AbortController();

    try {
      const params = new URLSearchParams({
        q: query,
        "resources[type]": "product",
        "resources[limit]": "5",
        "resources[options][unavailable_products]": "last",
      });
      const response = await fetch(`/search/suggest.json?${params.toString()}`, {
        headers: { Accept: "application/json" },
        signal: predictiveAbortController.signal,
      });
      if (!response.ok || token !== searchToken) return;
      const json = await response.json();
      const products = json?.resources?.results?.products || [];
      renderSuggestions(query, products.map(productSuggestion));
    } catch (error) {
      if (error.name !== "AbortError") renderSuggestions(query);
    }
  }

  function runSearchSuggestions() {
    if (!searchInput) return;
    const query = searchInput.value;
    searchToken += 1;
    searchClear.hidden = query.length === 0;
    renderSuggestions(query);
    fetchPredictiveSuggestions(query, searchToken);
  }

  async function updateCartCount() {
    const response = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!response.ok) return;
    const cart = await response.json();
    const count = cart.item_count || 0;

    document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
      bubble.hidden = false;
      const readable = bubble.querySelector("span[aria-hidden='true']") || bubble.querySelector(".cart-count");
      const hidden = bubble.querySelector(".visually-hidden");
      if (readable) readable.textContent = count;
      if (hidden) hidden.textContent = `${count} article${count > 1 ? "s" : ""}`;
    });

    document.querySelectorAll(".pill-cart__count").forEach((node) => {
      node.textContent = `(${count})`;
    });
  }

  async function quickAdd(button) {
    if (!button || button.classList.contains("is-loading")) return;
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.classList.add("is-loading");
    button.setAttribute("aria-busy", "true");

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });

      if (!response.ok) throw new Error("Cart add failed");
      await updateCartCount();
      button.classList.add("is-added");
      button.setAttribute("aria-label", "Ajouté au panier");
      window.setTimeout(() => {
        button.classList.remove("is-added");
        button.removeAttribute("aria-label");
      }, 1400);
    } catch (error) {
      const cardLink = button.closest("[data-product-card]")?.querySelector("a[href]");
      if (cardLink) window.location.href = cardLink.href;
    } finally {
      button.classList.remove("is-loading");
      button.removeAttribute("aria-busy");
    }
  }

  root.querySelectorAll("[data-facet-toggle]").forEach((button) => {
    button.addEventListener("click", () => {
      const panel = document.getElementById(button.getAttribute("aria-controls"));
      const expanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", String(!expanded));
      if (panel) panel.hidden = expanded;
    });
  });

  root.querySelectorAll("[data-facet-more]").forEach((button) => {
    button.addEventListener("click", () => {
      const group = button.closest(".facets-bouquet__group");
      const expanded = group?.classList.toggle("is-expanded");
      button.querySelector("span").textContent = expanded ? "Voir moins" : "Voir plus";
    });
  });

  filterForm?.addEventListener("change", (event) => {
    if (event.target.matches("[data-price-input]")) return;
    if (event.target.matches("[data-price-range-min], [data-price-range-max]")) return;
    submitFilterForm();
  });

  filterForm?.addEventListener("submit", () => {
    preparePriceSubmission();
    filterForm.querySelectorAll("[data-price-hidden]").forEach((input) => {
      if (!input.value.trim()) input.disabled = true;
    });
  });

  sortSelect?.addEventListener("change", (event) => {
    updateUrlParam("sort_by", event.target.value);
  });

  perPageSelect?.addEventListener("change", (event) => {
    updatePerPage(event.target.value);
  });

  openFiltersButton?.addEventListener("click", () => setDrawer(true));
  closeFiltersButton?.addEventListener("click", () => setDrawer(false));
  filterBackdrop?.addEventListener("click", () => setDrawer(false));

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && root.classList.contains("is-filter-open")) {
      setDrawer(false);
    }
  });

  root.addEventListener("click", (event) => {
    const button = event.target.closest("[data-collection-quick-add]");
    if (button) quickAdd(button);
  });

  searchInput?.addEventListener("input", runSearchSuggestions);
  searchInput?.addEventListener("focus", runSearchSuggestions);
  searchInput?.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      clearSuggestions();
      searchInput.blur();
    }
    if (event.key === "Enter") {
      const query = searchInput.value.trim();
      if (query) window.location.href = collectionSearchUrl(query);
    }
  });

  searchClear?.addEventListener("click", () => {
    searchInput.value = "";
    searchClear.hidden = true;
    clearSuggestions();
    searchInput.focus();
  });

  document.addEventListener("click", (event) => {
    if (searchWrap && !searchWrap.contains(event.target)) clearSuggestions();
  });

  viewButtons.forEach((button) => {
    button.addEventListener("click", () => setViewMode(button.dataset.viewMode));
  });

  try {
    setViewMode(window.localStorage.getItem(storageKey) || "grid");
  } catch (error) {
    setViewMode("grid");
  }

  if (searchInput) {
    const initialQuery = new URL(window.location.href).searchParams.get("q") || "";
    if (initialQuery.trim()) {
      searchInput.value = initialQuery.trim();
      if (searchClear) searchClear.hidden = false;
      runSearchSuggestions();
    }
  }

  initPriceSliders();
})();
